import { Mail, MapPin, Clock, Phone } from "lucide-react";
import { Reveal } from "@/components/Reveal";
import { Seo } from "@/components/Seo";
import { QuoteForm } from "@/components/QuoteForm";

export default function Contact() {
  return (
    <main data-testid="contact-page" className="bg-white">
      <Seo
        title="Contact | DEKO Kozijnen — Bel 06 40 62 74 99"
        description="Neem contact op met DEKO Kozijnen: bel 06 40 62 74 99, mail of stuur een bericht. Werkgebied Noord-Nederland, reactie binnen 1 werkdag."
      />
      <section className="pt-40 pb-20 mx-auto max-w-[1440px] px-6 md:px-10 grid grid-cols-1 lg:grid-cols-12 gap-14">
        <Reveal className="lg:col-span-5">
          <span className="text-xs uppercase tracking-[0.25em] text-[#222]/40">Contact</span>
          <h1 className="font-display font-extrabold text-4xl sm:text-5xl text-[#2F3438] mt-5 leading-tight">Neem contact op.</h1>
          <p className="text-[#222]/60 text-lg font-light leading-relaxed mt-6 max-w-md">
            Heeft u een vraag of wilt u een afspraak inplannen? Stuur ons een bericht of mail rechtstreeks. Wij reageren snel.
          </p>
          <div className="mt-10 space-y-6">
            <a href="tel:+31640627499" className="flex items-center gap-4 group" data-testid="contact-phone">
              <div className="h-11 w-11 rounded-sm bg-[#F7F7F5] flex items-center justify-center"><Phone className="h-5 w-5 text-[#2F3438]" /></div>
              <div>
                <div className="text-xs uppercase tracking-widest text-[#222]/40">Telefoon</div>
                <div className="text-[#2F3438] group-hover:underline">06 40 62 74 99</div>
              </div>
            </a>
            <a href="mailto:Noakoelhuis@live.nl" className="flex items-center gap-4 group" data-testid="contact-email">
              <div className="h-11 w-11 rounded-sm bg-[#F7F7F5] flex items-center justify-center"><Mail className="h-5 w-5 text-[#2F3438]" /></div>
              <div>
                <div className="text-xs uppercase tracking-widest text-[#222]/40">E-mail</div>
                <div className="text-[#2F3438] group-hover:underline">Noakoelhuis@live.nl</div>
              </div>
            </a>
            <div className="flex items-center gap-4">
              <div className="h-11 w-11 rounded-sm bg-[#F7F7F5] flex items-center justify-center"><MapPin className="h-5 w-5 text-[#2F3438]" /></div>
              <div>
                <div className="text-xs uppercase tracking-widest text-[#222]/40">Werkgebied</div>
                <div className="text-[#2F3438]">Noord-Nederland</div>
              </div>
            </div>
            <div className="flex items-center gap-4">
              <div className="h-11 w-11 rounded-sm bg-[#F7F7F5] flex items-center justify-center"><Clock className="h-5 w-5 text-[#2F3438]" /></div>
              <div>
                <div className="text-xs uppercase tracking-widest text-[#222]/40">Reactietijd</div>
                <div className="text-[#2F3438]">Binnen 1 werkdag</div>
              </div>
            </div>
          </div>
        </Reveal>
        <Reveal delay={0.1} className="lg:col-span-7">
          <div className="bg-[#F7F7F5] rounded-sm p-8 sm:p-10">
            <h2 className="font-display font-bold text-2xl text-[#2F3438] mb-6">Stuur ons een bericht</h2>
            <QuoteForm />
          </div>
        </Reveal>
      </section>
    </main>
  );
}
